'use strict';

angular.module('pointsOfFocusModule', []);